var map = {
	"./1minute.svg": 1484,
	"./24.svg": 1485,
	"./CloudGuard-Service.svg": 1486,
	"./DNS.svg": 1487,
	"./ManagedService-Service.svg": 1488,
	"./VPC-Service.svg": 1489,
	"./chooseOs.svg": 1490,
	"./console.svg": 1491,
	"./dashboard.svg": 1492,
	"./ddos-d.svg": 1493,
	"./ddos.svg": 1494,
	"./disaster.svg": 1495,
	"./firewall-new.svg": 1496,
	"./freeSupport.svg": 1497,
	"./global.svg": 1498,
	"./hq.svg": 1499,
	"./increase.svg": 1500,
	"./infrustructure.svg": 1501,
	"./list-vps.f735948 1.svg": 1502,
	"./sla.svg": 1503,
	"./startup.svg": 1504,
	"./support.svg": 1505,
	"./test.svg": 1506,
	"./traffic-vps.aa00c67 1.svg": 1507,
	"./uptime.svg": 1508,
	"./virtualOrganization.svg": 1509,
	"./waf-d.svg": 1510,
	"./waf-icon-active.svg": 1511,
	"./waf-icon.svg": 1512,
	"./waf-vps.fcecd73 1.svg": 1513,
	"./waf.svg": 1514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1566;